import { render, staticRenderFns } from "./tree-structure-picker.vue?vue&type=template&id=2a98d074&"
import script from "./tree-structure-picker.vue?vue&type=script&lang=js&"
export * from "./tree-structure-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tree-structure-picker.vue"
export default component.exports